import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import { axiosInstance } from "../../../config";
// import Sidebar from "../../components/sidebar/Sidebar";
import JoditEditor from "jodit-react";
import { AiFillCopy, AiTwotoneDelete } from "react-icons/ai";
import { axiosInstance } from "../../config";
import Sidebar from "../common/sidebar/Sidebar";

const EditBlog = () => {
  const navigate = useNavigate();

  const [apicall, setapicall] = useState({
    loading: false,
    error: false,
  });
  const [productimg, setproductimg] = useState();
  const [del, setdel] = useState(false);
  const [gallery, setgallery] = useState([]);

  const { loading, error } = apicall;

  const { id } = useParams();

  const [blog, setblog] = useState({});
  const [content, setContent] = useState("");

  const onChange = (e) => {
    setblog({ ...blog, [e.target.name]: e.target.value });
  };

  const { heading, description, keywords, author, url } = blog;

  useEffect(() => {
    getblog();
  }, []);

  useEffect(() => {
    getgallaryimg();
  }, [del]);

  const getblog = async () => {
    try {
      const { data } = await axiosInstance.get(`/api/blog/${id}`);
      if (data.success) {
        const { content, ...others } = data.blogdetails;
        setblog(others);
        setContent(content);
      }
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  const getgallaryimg = async () => {
    try {
      const { data } = await axiosInstance.get("/api/gallery");
      // console.log("data",data.gallery)

      if (data.success) {
        setgallery(data.gallery);
      }
    } catch (error) {
      console.log("err", error.response.data.message);
    }
  };

  const handleBlogSubmit = async (e) => {
    try {
      e.preventDefault();
      setapicall({ ...apicall, loading: true });

      const { data } = await axiosInstance.put(`/api/blog/${id}`, {
        heading,
        content,
        description,
        keywords,
        author,
        url,
      });

      if (data.success) {
        setapicall({ ...apicall, loading: false });
        navigate("/admin/blog");
      }
    } catch (error) {
      alert(error.response.data.message);
    }
  };

  const addimge = async (e) => {
    e.preventDefault();
    if (!productimg) {
      return alert("Please Select Image ");
    } else {
      if (productimg.size >= 2000000) {
        return alert("Image Size should be less Than 2MB");
      }
    }
    setapicall({ ...apicall, loading: true });
    try {
      const productdata = new FormData();
      productdata.append("blogimg", productimg);
      const { data } = await axiosInstance.post(`/api/gallery`, productdata, {
        headers: {
          token: localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      });

      if (data.success) {
        setapicall({ ...apicall, loading: false });
        alert(data.message);
      }
      alert("Image Added Successfully");
      setdel(!del);
    } catch (error) {
      setapicall({ ...apicall, loading: false });
      console.log(error);
    }
  };

  const deleteimage = async (id) => {
    // console.log("imgs",imgs,id)
    try {
      const answer = window.confirm("Are You Sure !");
      if (answer) {
        const { data } = await axiosInstance.delete(`/api/gallery/${id}`, {
          headers: {
            token: localStorage.getItem("token"),
          },
        });
        alert("deleted permanently");
      }
      setdel(!del);
    } catch (error) {
      console.log("error", error);
    }
  };

  const config = {
    uploader: {
      insertImageAsBase64URI: true,
    },
  };
  const togglehandle = (e) => {
    e.persist();
    var menu_btn = document.querySelector("#menu-btn");
    var sidebar = document.querySelector("#sidebar");
    var container = document.querySelector(".my-container");
    sidebar.classList.toggle("active-nav");
    container.classList.toggle("active-cont");
  };


  return (
    <>
      <Sidebar />
      <div className="p-1 my-container active-cont">
        {/* <!-- Top Nav --> */}
        <nav className="navbar top-navbar navbar-light bg-light px-5">
          <a className="btn border-0" id="menu-btn" onClick={togglehandle}>
            <i className="bx bx-menu"></i>
          </a>
        </nav>
        {/* <!--End Top Nav --> */}
        <h3 className="text-dark p-3">ADMIN EDIT BLOG 💻 📱</h3>

        <div className="row mx-2 " style={{ backgroundColor: "#FDF8DB" }}>
          <form onSubmit={handleBlogSubmit}>
            <div class="mb-1">
              <label for="exampleInputEmail1" class="form-label">
                Heading
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                value={heading}
                name="heading"
                onChange={onChange}
                aria-describedby="emailHelp"
              />
            </div>
    
            <div class="mb-1">
              <label for="exampleInputEmail1" class="form-label">
                Description
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                value={description}
                name="description"
                onChange={onChange}
                aria-describedby="emailHelp"
              />
            </div>
            <div class="mb-1">
              <label for="exampleInputEmail1" class="form-label">
                Keywords
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                value={keywords}
                name="keywords"
                onChange={onChange}
                aria-describedby="emailHelp"
              />
            </div>
            <div class="mb-1">
              <label for="exampleInputEmail1" class="form-label">
                Author
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                name="author"
                value={author}
                onChange={onChange}
                aria-describedby="emailHelp"
              />
            </div>
            <div class="mb-1">
              <label for="exampleInputEmail1" class="form-label">
                Url
              </label>
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                name="url"
                value={url}
                onChange={onChange}
                aria-describedby="emailHelp"
              />
            </div>
            <div class="mb-1">
              <label for="exampleInputEmail1" class="form-label">
                Content
              </label>
              <JoditEditor
                // ref={editor}
                value={content}
                config={config}
                tabIndex={1} // tabIndex of textarea
                onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                onChange={(newContent) => {}}
              />
            </div>

            {loading ? (
              <>
                <button
                  type="submit"
                  class="btn mybtn btn btn-success text-white mt-2 disabled"
                >
                  <div class="spinner-border" role="status">
                    {/* <span class="sr-only">Loading...</span> */}
                  </div>
                </button>
              </>
            ) : (
              <button type="submit" class="btn mybtn  btn-success text-white mt-2">
                Submit
              </button>
            )}

            {/* <button type="submit" class="btn btn btn-success text-white">Submit</button> */}
          </form>
          {/* <div className="toogler"><h3>Add Review</h3></div> */}
        </div>
      </div>
    </>
  );
};

export default EditBlog;
